/* @jsxImportSource react */

import type { CSSProperties } from 'react';
import { cn } from '@packages/shared/src/utils/cn/cn';
import { Image, getImageSize } from '@packages/shared/src/ui/Image/Image';

export interface ProductCardV2ImageProps {
  /** URL of the product image */
  src: string;
  /** Alt text for the image */
  alt: string;
  /** Whether to preload the image */
  priority?: boolean;
  //   TODO check if actually still needed
  /** Whether to shrink image to fit container */
  shrinkToFit?: boolean;
  /** Additional classes */
  className?: string;
  /** Maximum height the image should take, taken from image dimensions (according to CDN format) when omitted */
  maxImageHeight?: string;
}

interface CssWithCustomProperties extends CSSProperties {
  '--max-image-height': string;
}

export const ProductCardV2Image = ({
  src,
  alt,
  priority,
  shrinkToFit = false,
  className,
  maxImageHeight,
}: ProductCardV2ImageProps) => {
  // Use default image for prototypes and storybook
  const imageSize = getImageSize(src) ?? { width: 339, height: 485 };

  const cssProperties: CssWithCustomProperties = {
    '--max-image-height': shrinkToFit ? 'auto' : (maxImageHeight ?? `${imageSize.height}px`),
  };

  return (
    <div
      className={cn(
        'product-card-image max-h-[var(--max-image-height)] overflow-hidden [grid-area:1/2/span_1/span_1]',
        className,
      )}
      style={cssProperties}
    >
      <Image
        src={src}
        alt={alt}
        width={imageSize.width}
        height={imageSize.height}
        priority={priority}
        className="h-auto max-h-full w-full max-w-full object-contain"
      />
    </div>
  );
};
